import axiosInstance from 'core/network/axiosInstance'

export interface AdminNotificationItem {
  id: string
  recipient_id: string
  channel: string
  type: string
  title: string
  message: string
  data?: Record<string, unknown>
  action_url?: string
  read_at?: string | null
  created_at: string
}

export interface AdminNotificationListResponse {
  skip: number
  limit: number
  total: number
  data: AdminNotificationItem[]
}

export interface UnreadCountResponse {
  count: number
}

export interface GetAdminNotificationsParams {
  skip?: number
  limit?: number
  type?: string
  unread_only?: boolean
}

class NotificationsApi {
  async getNotifications(params?: GetAdminNotificationsParams): Promise<AdminNotificationListResponse> {
    const { data } = await axiosInstance.get<AdminNotificationListResponse>('/api/v1/notifications', { params })
    return data
  }

  async getUnreadCount(): Promise<number> {
    const { data } = await axiosInstance.get<UnreadCountResponse>('/api/v1/notifications/unread-count')
    return data.count
  }

  async markAsRead(id: string): Promise<void> {
    await axiosInstance.patch(`/api/v1/notifications/${id}/read`)
  }

  async markAllAsRead(): Promise<void> {
    await axiosInstance.patch('/api/v1/notifications/read-all')
  }
}

export const notificationsApi = new NotificationsApi()
